import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Acme",
    title: "Best printing. Best price.",
    content: "We offer the best printing services at unbeatable prices. Quality you can trust.",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Acme",
    title: "Quality printing for less",
    content: "We offer the best printing services at unbeatable prices. Quality you can trust.",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Acme",
    title: "Dedicated to excellence",
    content: "We offer the best printing services at unbeatable prices. Quality you can trust.",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
];

export default home;